import React, { useEffect, useState } from "react";
import { Drawer, Box, Typography, alpha, Avatar, styled } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTheme } from "@mui/material/styles";
import { ReactComponent as Close } from '../../../assets/images/close-circle.svg'
import { BorderRight } from "@mui/icons-material";
import Search from '../../../assets/images/search-normal.svg'
import InputComponent from "src/components/shared/Form/Input";
import theme, { mobileTypography, palette, shadows, typography } from "src/config/theme";
import { ReactComponent as UpArrow } from '../../../assets/images/arrow-up.svg';
import { ReactComponent as DownArrow } from '../../../assets/images/arrow-down.svg';
import { ReactComponent as RightArrow } from '../../../assets/images/arrow-right 2.svg'
import NoDataFound from "src/modules/app/components/NoDataFound/NoDataFound";
import { getAppointmentRequest } from "src/modules/app/store/appActions";
import {
  useDispatch,
  useSelector
} from "react-redux";
import storage from "src/utils/storageUtils";
import { isSanginiRestrictedUser } from "src/utils/sanginiUtils";
import useResponsive from "src/components/hooks/useResponsive";
import { useNavigate } from 'react-router-dom';

export const SearchBox = styled(Box)({
  padding: '10px 18px',
  border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
  borderRadius: '12px',
  width: '332px',
  height: '52px',
  backgroundColor: palette.gery.white,
  boxShadow: shadows[1],
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  [theme.breakpoints.down('md')]: {
    width: '290px',
    height: '44px'
  },
})
export const SearchIcon = styled(Avatar)({
  position: 'relative',
  width: '24px',
  height: '24px',
  [theme.breakpoints.down('md')]: {
    width: '18px',
    height: '18px'
  },
})
export const ListBox = styled(Box)({
  width: '332px',
  // height:'110px',
  borderRadius: '12px',
  boxShadow: shadows[1],
  border: `1px solid ${alpha(palette.gery.black, 0.10)}`,
  backgroundColor: palette.gery.white,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  gap: '10px',
  alignSelf: 'stretch',
  position: 'relative',
  [theme.breakpoints.down('md')]: {
    width: '280px',
    alignItems: 'flex-start'
  },
})
export const ListInner = styled(Box)({
  width: '312px',
  height: '110px',
  flexShrink: 0,
  [theme.breakpoints.down('md')]: {
    width: 'auto !important'
  },
})
export const Box1 = styled(Box)({
  display: 'inline-flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '4px',
  margin: '16px 0 0 10px'
})
export const Box2 = styled(Box)({
  width: '144px',
  height: '22px',
  margin: '12px 0 0 10px',
  display: 'flex',
  gap: '8px',
  alignItems: 'center'
})
export const Dot = styled(Box)({
  width: '8px',
  height: '8px',
  borderRadius: '4px',
  backgroundColor: theme.palette.action.green,
})
export const VerticalBorder = styled(Box)({
  height: '110px',
  border: `1px solid ${theme.palette.primary.light1}`,
  position: 'absolute',
  right: '17%',
  [theme.breakpoints.down('md')]: {
    right: '19%'
  },
})
export const HorizontalBorder = styled(Box)({
  height: '56px',
  border: `1px solid ${theme.palette.primary.light1}`,
  position: 'absolute',
  transform: 'rotate(-90deg)',
  position: 'absolute',
  top: '25%',
  right: '8.2%',
  [theme.breakpoints.down('md')]: {
    right: '9.2%'
  },
})
export const TwoIcon = styled(Box)({
  position: 'absolute',
  width: '24px',
  height: '24px',
  top: '70px',
  left: '292px',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  // gap:'1px'
  [theme.breakpoints.down('md')]: {
    left: '240px'
  },
})
const RightSidebar = ({ open, onClose }) => {
  const { isMobile, isTablet, isDesktop } = useResponsive();
  const [appointments, setAppointments] = useState([]);
  const [searchText, setSearchText] = useState('')
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedIndex, setSelectedIndex] = useState(null);

  const formatTime = (time) => {
    if (typeof time === 'string' && !time.includes('T')) return time;
    try {
      const dateObj = new Date(time);
      return dateObj.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
    } catch (e) {
      return 'Invalid Time';
    }
  };
  useEffect(() => {
    if (open) {
      const fetchData = async () => {
        try {
          const token = storage.get('TOKEN');
          const response = await new Promise((resolve, reject) => {
                dispatch(getAppointmentRequest({ token, params: { recordStatus: 'In Queue,Attending Now', limit: 100 } }, resolve, reject));
            });

          if (response && response.data) {
            setAppointments(response.data);

            if (response.data.length > 0) {
              setSelectedIndex(0);
            }
          }
        } catch (err) {
          console.warn('Sidebar appointments not available:', err?.message || err);
        }
      };
      fetchData();
    }
  }, [dispatch, open]);


  const user = useSelector((state) => state.auth?.user);
  const isSangini = isSanginiRestrictedUser(user);

  const handleAttendNowAppointment = (appointmentId, index) => {
    setSelectedIndex(index);
    if (!isSangini) {
      onClose();
      navigate(`/appointment/Patients/${appointmentId}`);
    }
  };

  const swapAppointments = (index1, index2) => {
    if (
      index1 < 0 ||
      index2 < 0 ||
      index1 >= appointments.length ||
      index2 >= appointments.length
    ) return;

    const newAppointments = [...appointments];
    const temp = newAppointments[index1];
    newAppointments[index1] = newAppointments[index2];
    newAppointments[index2] = temp;

    setAppointments(newAppointments);
  };


  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: isMobile || isTablet ? '330px' : '380px',
          height: isMobile || isTablet ? '844' : '1080px',
          borderLeft: `1px solid ${theme.palette.primary.light1}`
        },
      }}
    >
      <Box sx={{
        height: isMobile || isTablet ? '72px' : '84px',
        backgroundColor: theme.palette.primary.light3,
        border: `1px solid ${theme.palette.primary.light1}`,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
        <Box sx={{ width: isMobile || isTablet ? '290px' : '332px', height: '24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography
            sx={{
              ...((isMobile || isTablet) ? mobileTypography.h4 : typography.h3)
            }}>OPD Queue</Typography>



          <Close width={isMobile || isTablet ? 18 : 24}
            height={isMobile || isTablet ? 18 : 24} onClick={onClose} sx={{ color: theme.palette.gery.black }} style={{ cursor: 'pointer' }} />
        </Box >
      </Box >
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '32px 24px' }}>
        <SearchBox>
          <SearchIcon src={Search} />
          <InputComponent
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            placeholder="Search"
            variant="outlined" sx={{
              // paddingLeft: ,
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  border: "none",
                  width: 'auto'
                },
                "& input": {
                  paddingLeft: 0,
                  paddingRight: 0,
                },
                "& .MuiInputBase-input.MuiOutlinedInput-input": {
                  ...(isMobile || isTablet ? theme.mobileTypography.body2 : theme.typography.h5),
                },
              },
            }} />
          {/* <SearchText placeholder="Search..." /> */}
        </SearchBox>
      </Box>
      {appointments.length === 0 ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', gap: '16px', margin: '0 24px', height: '40%' }}>
          <NoDataFound
            title="Queue Empty!"
            showButton={false}
            description={
              <>
                No Data to Showcase <br />
                <span style={{ color: theme.palette.gery.black }}>Click “Add to Queue”</span> from Appointments.
              </>
            }
          />
        </Box>
      ) : (
        <Box sx={{
          overflowY: 'auto',
          maxHeight: 'calc(100vh - 100px)',
          paddingBottom: '16px',
        }}>
          {appointments.filter(data =>
            data?.patient?.fullName?.toLowerCase().includes(searchText.toLowerCase())
          ).map((data, index) => (
            <Box key={data.id} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start', flexDirection: 'column', gap: '16px', margin: '10px 24px', }}>
              <ListBox>
                <ListInner>
                  <Box1>
                    <Typography sx={{
                      color: theme.palette.primary.main,
                      ...((isMobile || isTablet) ? mobileTypography.h5 : typography.h5)
                    }}>
                      {data?.scheduleType === 'token' && data?.tokenNumber ? `#${data.tokenNumber} - ` : ''}
                      {data?.patient?.fullName}
                    </Typography>
                    <Typography sx={{
                      color: `${alpha(theme.palette.gery.black, 0.70)}`,
                      ...((isMobile || isTablet) ? mobileTypography.body2 : typography.body1)
                    }}>{new Date(data.date).toLocaleDateString('en-GB', {
                      day: '2-digit', month: 'short', year: 'numeric'
                    }) + `, ${formatTime(data.time)}`}</Typography>
                  </Box1>
                  <Box2 onClick={() => handleAttendNowAppointment(data.id, index)} sx={{ cursor: 'pointer' }}>
                    {data.recordStatus === 'Attending Now' ? (
                      <>
                        <Dot />
                        <Typography variant="small" sx={{ color: theme.palette.action.green, fontSize: '14px' }}>
                          Attending Now
                        </Typography>
                      </>
                    ) : (
                      <>
                        <Typography variant="small" sx={{ color: theme.palette.primary.main, fontSize: '14px' }}>
                          Attend Now
                        </Typography>
                        <RightArrow width={18} height={18} style={{ color: theme.palette.primary.main }} />
                      </>
                    )}
                  </Box2>
                </ListInner>
                {/* <VerticalBorder />
                <HorizontalBorder />
                <Close width={isMobile || isTablet ? 18 : 24}
                  height={isMobile || isTablet ? 18 : 24} style={{
                    position: 'absolute',
                    top: '16px',
                    left: isMobile || isTablet ? '242px' : '292px',
                    cursor: 'pointer',
                  }} /> */}
                <TwoIcon>
                  <UpArrow
                    style={{ color: index === 0 ? '#ccc' : theme.palette.primary.main, cursor: index === 0 ? 'not-allowed' : 'pointer' }}
                    onClick={() => index > 0 && swapAppointments(index, index - 1)}
                  />
                  <DownArrow
                    style={{ color: index === appointments.length - 1 ? '#ccc' : theme.palette.primary.main, cursor: index === appointments.length - 1 ? 'not-allowed' : 'pointer' }}
                    onClick={() => index < appointments.length - 1 && swapAppointments(index, index + 1)}
                  />

                </TwoIcon>
              </ListBox>
            </Box>
          ))}
        </Box>
      )}
    </Drawer>
  );
};
export default RightSidebar;
